import FileSaver from 'file-saver';

/**
 * 파일 다운로드
 * @param blob - 다운로드할 파일 blob
 * @param filename - 다운로드할 파일명
 */
export function download(blob, filename) {
    FileSaver.saveAs(blob, filename);
}

/**
 * 파일 확장자 반환
 * @param fileName
 * @returns {string}
 */
export function getExtension(fileName) {
    return fileName.substr(fileName.lastIndexOf(".") + 1).toLowerCase();
}

/**
 * 파일 확장별 css class
 * @param fileName
 * @returns {string}
 */
export function getExtensionClassName (fileName) {
    let ext = getExtension(fileName);
    switch (ext) {
        case 'xls' :
        case 'xlsx' :
            return 'excel';
        case 'doc' :
        case 'docx' :
            return 'word';
        case 'ppt':
        case 'pptx':
            return 'ppt';
        case 'pdf':
            return 'pdf';
        case 'hwp':
        case 'hwpx':
            return 'hwp';
        case 'png':
            return 'png';
        case 'jpg':
        case 'jpeg':
            return 'jpg';
        case 'gif':
            return 'gfi';
        default :
            return 'etc';
    }
}

/**
 * 읽기 좋은 파일 사이즈 텍스트
 * @param fileSize
 * @returns {string}
 */
export function getReadableSize(fileSize){
    if(fileSize < 1024){
        return '1KB';
    }

    if(fileSize < 1048576) {
        return (fileSize/1024).toFixed(2) + 'KB';
    }

    return (fileSize/1048576).toFixed(2) + 'MB';
}
